import { gql, useQuery } from '@apollo/client';
import { Box, Heading, Stack } from '@chakra-ui/react';
import * as React from 'react';

import { Redraft } from '@/components/Redraft';
import { Prose } from '@/imports/ui/chakra/components/Prose';
import { MilleFeuille, MilleFeuilleMain } from '@/layouts/MilleFeuille';
import { FooterRender } from '@/modules/website-builder';
import { TENANT_FRAGMENT } from '@/queries';

import { PrivacyPolicy_TenantAndPrivacyPolicy } from './graphql-types/PrivacyPolicy_TenantAndPrivacyPolicy';

const TENANT_AND_PRIVACY_POLICY = gql`
  query PrivacyPolicy_TenantAndPrivacyPolicy {
    tenant {
      result {
        _id
        privacyPolicy
        ...TenantFragment
      }
    }
  }
  ${TENANT_FRAGMENT}
`;

export const PrivacyPolicy: React.FC = () => {
  const { data } = useQuery<PrivacyPolicy_TenantAndPrivacyPolicy>(
    TENANT_AND_PRIVACY_POLICY
  );

  return (
    <MilleFeuille>
      <MilleFeuilleMain>
        <Box maxW="container.md" mx="auto" p="10">
          <Stack spacing="10">
            <Heading size="xl">Privacy Policy</Heading>
            {data?.tenant.result?.privacyPolicy && (
              <Prose>
                <Redraft
                  rawDraftContentState={data.tenant.result.privacyPolicy}
                />
              </Prose>
            )}
          </Stack>
        </Box>
      </MilleFeuilleMain>
      {data?.tenant.result && <FooterRender tenant={data.tenant.result} />}
    </MilleFeuille>
  );
};
